"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var minimal_1 = require("@sentry/minimal");
var is_1 = require("@sentry/utils/is");
var misc_1 = require("@sentry/utils/misc");
var logger_1 = require("../logger");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */function () {
  function InboundFilters() {
    /** JSDoc */
    this.ignoreErrors = DEFAULT_IGNORE_ERRORS;
    /**
     * @inheritDoc
     */
    this.name = 'InboundFilters';
  }
  /**
   * @inheritDoc
   */
  InboundFilters.prototype.install = function (options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    this.configureOptions(options);
    minimal_1.configureScope(function (scope) {
      scope.addEventProcessor(function (event) {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            if (this.shouldDropEvent(event)) {
              return [2 /*return*/, null];
            }
            return [2 /*return*/, event];
          });
        });
      });
    });
  };
  /** JSDoc */
  InboundFilters.prototype.shouldDropEvent = function (event) {
    if (this.isIgnoredError(event)) {
      logger_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + misc_1.getEventDescription(event));
      return true;
    }
    if (this.isBlacklistedUrl(event)) {
      logger_1.logger.warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + misc_1.getEventDescription(event) + ".\nUrl: " + this.getEventFilterUrl(event));
      return true;
    }
    if (!this.isWhitelistedUrl(event)) {
      logger_1.logger.warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + misc_1.getEventDescription(event) + ".\nUrl: " + this.getEventFilterUrl(event));
      return true;
    }
    return false;
  };
  /** JSDoc */
  InboundFilters.prototype.isIgnoredError = function (event) {
    var _this = this;
    if (!this.ignoreErrors) {
      return false;
    }
    return this.getPossibleEventMessages(event).some(function (message) {
      // Not sure why TypeScript complains here...
      return _this.ignoreErrors.some(function (pattern) {
        return _this.isMatchingPattern(message, pattern);
      });
    });
  };
  /** JSDoc */
  InboundFilters.prototype.isBlacklistedUrl = function (event) {
    var _this = this;
    // TODO: Use Glob instead?
    if (!this.blacklistUrls) {
      return false;
    }
    var url = this.getEventFilterUrl(event);
    return !url ? false : this.blacklistUrls.some(function (pattern) {
      return _this.isMatchingPattern(url, pattern);
    });
  };
  /** JSDoc */
  InboundFilters.prototype.isWhitelistedUrl = function (event) {
    var _this = this;
    // TODO: Use Glob instead?
    if (!this.whitelistUrls) {
      return true;
    }
    var url = this.getEventFilterUrl(event);
    return !url ? true : this.whitelistUrls.some(function (pattern) {
      return _this.isMatchingPattern(url, pattern);
    });
  };
  /** JSDoc */
  InboundFilters.prototype.isMatchingPattern = function (value, pattern) {
    if (is_1.isRegExp(pattern)) {
      return pattern.test(value);
    } else if (typeof pattern === 'string') {
      return value.includes(pattern);
    } else {
      return false;
    }
  };
  /** JSDoc */
  InboundFilters.prototype.configureOptions = function (options) {
    if (options.ignoreErrors) {
      this.ignoreErrors = __spread(DEFAULT_IGNORE_ERRORS, options.ignoreErrors);
    }
    if (options.blacklistUrls) {
      this.blacklistUrls = __spread(options.blacklistUrls);
    }
    if (options.whitelistUrls) {
      this.whitelistUrls = __spread(options.whitelistUrls);
    }
  };
  /** JSDoc */
  InboundFilters.prototype.getPossibleEventMessages = function (event) {
    if (event.message) {
      return [event.message];
    } else if (event.exception) {
      try {
        // tslint:disable-next-line:no-unsafe-any
        var _a = event.exception.values[0],
          type = _a.type,
          value = _a.value;
        return ["" + value, type + ": " + value];
      } catch (oO) {
        logger_1.logger.error("Cannot extract message for event " + misc_1.getEventDescription(event));
        return [];
      }
    } else {
      return [];
    }
  };
  /** JSDoc */
  InboundFilters.prototype.getEventFilterUrl = function (event) {
    try {
      if (event.stacktrace) {
        // tslint:disable-next-line:no-unsafe-any
        return event.stacktrace.frames[0].filename;
      } else if (event.exception) {
        // tslint:disable-next-line:no-unsafe-any
        return event.exception.values[0].stacktrace.frames[0].filename;
      } else {
        return null;
      }
    } catch (oO) {
      logger_1.logger.error("Cannot extract url for event " + misc_1.getEventDescription(event));
      return null;
    }
  };
  return InboundFilters;
}();
exports.InboundFilters = InboundFilters;